/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IIsEditorBundleUploadedResponse extends IMessage {
	isUploaded: boolean;
}

export default class IsEditorBundleUploadedResponse extends Message {
	public static readonly DESCRIPTOR_NAME: string = 'IsEditorBundleUploadedResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			isUploaded: {
				type: 'bool',
				id: 1
			}
		}
	};

	public constructor( public readonly isUploaded: boolean ) {
		super();
	}

	public toJSON(): IIsEditorBundleUploadedResponse {
		return {
			isUploaded: this.isUploaded
		};
	}

	public static fromJSON( json: IIsEditorBundleUploadedResponse ): IsEditorBundleUploadedResponse {
		return new IsEditorBundleUploadedResponse(
			json.isUploaded
		);
	}
}
